// @ts-nocheck
export const selectVoucherDetails = state => state.voucher.voucherDetails;
